import axios from 'axios';
import {
  loginRequestDataType,
  verifyElegibilityDataType,
  loginWithOrganismeRequestDataType,
} from 'store/user/types';
import { getApiBaseUrl, getApiGatewayBaseUrl } from 'helpers/api';
import axiosInstance from 'utils/axiosInstance';

const baseUrl = getApiBaseUrl();
const baseUrlGateway = getApiGatewayBaseUrl();

type EmailSubsciptionType = {
  email: string;
  token: string;
  language: string;
};

type EmailVerificationType = {
  pin: string;
  token: string;
};
export function userLogin(data: loginRequestDataType) {
  /* istanbul ignore next */
  return axios.post(`${baseUrl}/user/login`, data);
}

export function userLogout() {
  /* istanbul ignore next */
  return axiosInstance.post(`${baseUrlGateway}/api/v1/user/logout`);
}

export const loginWithOrganisme = (data: loginWithOrganismeRequestDataType) =>
  axios.post(`${baseUrl}/user/login-by-orga`, data);

export function verifyElegibility(data: verifyElegibilityDataType) {
  return axios.post(`${baseUrl}/user/verifyElegibility`, data);
}

export function sendLoginViaMailOnboarding({
  email,
  login,
  token,
  language,
}: {
  email: string;
  login: string;
  token: string;
  language: string;
}) {
  return axios.post(
    `${baseUrl}/user/sendLoginViaMail/${login}`,
    {
      token,
      email,
      login,
    },
    {
      params: {
        email,
        language,
      },
    },
  );
}

export function addNewUser(data: any) {
  return axios.post(`${baseUrl}/user`, data);
}

export const addAmcUser = (data: any) =>
  axios.post(`${baseUrl}/health/user`, data);

export function verifySms(data: { pin: string; pinId: string; token: string }) {
  return axios.post(`${baseUrl}/user/verifyPinSmsing`, data);
}

export function verifyAmcSms(data: {
  pin: string;
  pinId: string;
  token: string;
}) {
  return axios.post(`${baseUrl}/user/verifyPinSmsingAMC`, data);
}

export async function getProfileSettingsInfoApi(login: string) {
  return axiosInstance.get(`/user/settings/profil/getInfos`, {
    params: { login },
  });
}

export function updateProfileSettingsInfoAPI(data: any) {
  return axiosInstance.post('/user/settings/profil/editProfile', data);
}

export function getUserInfoAPI() {
  return axiosInstance.get('/user/decode-token');
}
export function verifySmsEpargnUnvalidUser(data: {
  pin: string;
  pinId: string;
  token: string;
}) {
  return axios.post(`${baseUrl}/user/verifyPinSmsingEpargn`, data);
}

export function sendEmailSubscription(data: EmailSubsciptionType) {
  return axios.post(
    `${baseUrl}/user/send-email-verification-subscription`,
    data,
  );
}

export function verifyEmail(data: EmailVerificationType) {
  return axios.post(`${baseUrl}/user/verify-email-code-subscription`, data);
}
export function verifyIdentityAPI() {
  return axiosInstance.post('/send-SMS');
}
export async function getOrganismesApi() {
  return await axiosInstance.post(`${baseUrl}/health/amcDMPolicies`);
}

export async function getDecompOrganismesApi() {
  return await axiosInstance.post(`${baseUrl}/health/amcDecomptePolicies`);
}

/* istanbul ignore next */
export async function buildDecompApi(payload: BuildDecompteApiType) {
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${payload?.token}`,
    sessionid: `${payload?.sessionsId}`,
  };
  /* istanbul ignore next */
  return await axios.post(
    `${baseUrlGateway}/mobile/api/deocmpte-v1/build_decompte`,
    payload,
    { headers: headers },
  );
}

interface tokenApiType {
  identifiant: undefined | string;
  token: string;
  username: string;
}
export async function getTokenApi(data: tokenApiType) {
  /* istanbul ignore next */
  return await axiosInstance.post(`${baseUrl}/dm/token`, data);
}

interface loadParameterApiType {
  NumIdentification: string;
  NumPolice: string;
  idAdherent: string;
  sessionsId: string;
  token: string;
}
/* istanbul ignore next */
export async function getLoadParameters(data: loadParameterApiType) {
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${data?.token}`,
    sessionid: `${data?.sessionsId}`,
  };
  /* istanbul ignore next */
  return await axios.post(`${baseUrl}/dm/LoadParametrageDM`, data, {
    headers: headers,
  });
}

interface ListPersonneChargeApiType {
  NumIdentification: string;
  NumPolice: string;
  sessionsId: string;
  token: string;
}

interface GetListPACApiType {
  NumPolice: string;
  identifiant: string;
  token: string;
  sessionsId: string;
}

interface BuildDecompteApiType {
  numSinistre: String;
  token: string;
  sessionsId: string;
}

/* istanbul ignore next */
export async function getListPersonneChargeApi(
  data: ListPersonneChargeApiType,
) {
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${data?.token}`,
    sessionid: `${data?.sessionsId}`,
  };
  /* istanbul ignore next */
  return await axios.post(`${baseUrl}/dm/GetListePersonneACharge`, data, {
    headers: headers,
  });
}

export interface createFolderProcessApiType {
  Canal: String;
  CanalDemande: String;
  DateConsultation: String;
  Email: String;
  Files: [];
  Frais: String;
  Gsm: String;
  IdAdherent: String;
  IdPersonneACharge: String;
  MondatoryFiles: [];
  NomPrenomAdherent: String;
  NomPrenomAssurePrincipal: String;
  NumIdentification: String;
  NumPolice: String;
  TypeDossier: String;
  sessionsId: String;
  token: String;
}
/* istanbul ignore next */
export async function postCreateFolderProcess(
  data: createFolderProcessApiType,
) {
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${data?.token}`,
    sessionid: `${data?.sessionsId}`,
  };
  /* istanbul ignore next */
  return await axios.post(`${baseUrl}/dm/CreerDM`, data, {
    headers: headers,
  });
}
interface payloadCheckFirstDeclaration {
  IdUser: string;
  token: string;
  sessionsId: string;
  idAdherent: string;
}
/* istanbul ignore next */
export function checkFirstDeclaration(payload: payloadCheckFirstDeclaration) {
  /* istanbul ignore next */
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${payload.token}`,
    sessionid: `${payload.sessionsId}`,
  };
  /* istanbul ignore next */
  return axios.post(`${baseUrl}/dm/CheckFirstDeclaration`, payload, {
    headers: headers,
  });
}

/* istanbul ignore next */
export function getListDossiers(payload: ListPersonneChargeApiType) {
  /* istanbul ignore next */
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${payload.token}`,
    sessionid: `${payload.sessionsId}`,
  };
  /* istanbul ignore next */
  return axios.post(`${baseUrl}/dm/GetDossiers`, payload, {
    headers: headers,
  });
}
/* istanbul ignore next */
export function getPACHistory(payload: GetListPACApiType) {
  /* istanbul ignore next */
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${payload.token}`,
    sessionid: `${payload.sessionsId}`,
  };
  /* istanbul ignore next */
  return axios.post(
    `${baseUrlGateway}/mobile/v1/api/pac/SuiviDemandePac`,
    payload,
    {
      headers: headers,
    },
  );
}
